import * as yup from 'yup';

const ForgotPasswordSchema = yup.object({
  email: yup.string().email('Enter a valid email').required('Email is required'),
});

export { ForgotPasswordSchema };
